import React from 'react';

import { Modal as CastlecraftModal } from 'castlecraft-ui';

const Modal = ({ headerText, closeModal, showModal, children }) => {
  return (
    <CastlecraftModal
      size="lg"
      open={!!showModal}
      onClose={() => closeModal()}
      title={headerText}
    >
      {children}
    </CastlecraftModal>
  );
};

export default Modal;
